import { Instance, types, flow, cast } from "mobx-state-tree";
import axios from "axios";
import { INVOICES_API } from "@constants/api";
import { AlertResultApi } from "@utils//alert";
import { fetching, FetchingEnum } from "./Fetching";

export const initialStateInvoices = {
  fetching: FetchingEnum.DONE,
};

const Item = types.model({
  description: types.maybeNull(types.string),
  no: types.number,
  qty: types.number,
  unitPrice: types.number,
});

const Invoice = types.model({
  amountDue: types.number,
  amountPaid: types.number,
  customerId: types.number,
  date: types.string,
  documentDate: types.string,
  dueDate: types.string,
  id: types.number,
  number: types.string,
  pdfUrl: types.string,
  status: types.string,
  subTotal: types.number,
  total: types.number,
  totalTax: types.number,
  items: types.optional(types.array(Item), []),
});

export const Invoices = types
  .model({
    fetching: fetching,
    invoice: types.maybeNull(Invoice),
    status: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getInvoices: flow(function* (
      token: string,
      invoiceId: number,
      callback: (x: InvoiceType) => void
    ) {
      self.fetching = FetchingEnum.PENDING;
      self.invoice = null;
      self.status = null;
      try {
        const response = yield axios.get(`${INVOICES_API}/${invoiceId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        self.status = response.status;
        console.log(response.data);
        self.invoice = response.data;
        self.fetching = FetchingEnum.DONE;
        callback(response.data);
      } catch (error) {
        self.fetching = FetchingEnum.DONE;
        self.invoice = null;
        console.log(error);
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }));

export type InvoiceType = Instance<typeof Invoice>;
